export const CONFIG_DORCHESTER = {
  styles: `
    :host {
      --sb-modal-radius: 10px;
      --sb-widget-padding: 18px;
      --sb-widget-radius: 8px;
    }
    .trigger__btn-text,
    .submit__btn-text,
    .destination__option__text,
    .guests__room-number,
    .promo__apply-btn__text {
      position: relative;
      top: -1px;
    }
    .trigger__btn-text--destination--unselected,
    .trigger__btn-text--calendar--unselected,
    .trigger__btn-text--promo {
      text-transform: lowercase;
    }
    .submit__btn-text {
      text-transform: uppercase;
    }
    .trigger__btn-text--destination--unselected:first-letter,
    .trigger__btn-text--calendar--unselected:first-letter,
    .trigger__btn-text--promo:first-letter,
    .submit__btn-text:first-letter {
      text-transform: capitalize;
    }
    .widget--inner {
      gap: 16px;
    }
    .trigger-row {
      gap: calc(25% - 200px);
    }
    @media all and (height < 700px) {
      .mobile-only {
        display: var(--mobile-display, block);
      }
      .desktop-only {
        display: none;
      }
    }
  `,
  fontFamily: '"acumin-pro", sans-serif',
  triggers: {
    shape: 'square',
    showIconLeft: true,
    showIconRight: true,
  },
  calendar: {
    showPrices: true,
  },
  theme: {
    tokens: {
      heading: {
        "compact-01": {
          letterSpacing: 0.24,
        },
        "01": {
          letterSpacing: 0.24,
        },
        "03": {
          letterSpacing: 0.16,
        },
        "05": {
          letterSpacing: -0.16,
        },
        "07": {
          letterSpacing: -0.48,
        },
      },
    },
  },
};
